import { Segment } from './segments';

export class Company {
    uid: string;
    name: string;
    cnpj: string;
    segmentUID: Segment;
    photoURL: string;
    headerLogo: string;
    address: Address;
    phone: string;

    searchID: string;

    products: string[];

    contractDate: number;
    contractDateString: string;
    metaField: number;
    fee: number;
    firstFeeDate: number;
    firstFeeDateString: string;
    contractCancelDate: number;
    contractCancelDateString: string;
    commission: string;

    source: CompanySource;

    salesPerson: string;
    salesPersonCommission: string;
    manager: string;
    managerCommission: string;

    consultingPerson: string;
    consultingPersonCommission: string;
    operationsManager: string;
    operationsManagerCommission: string;

    otherComment: string;

    indicatingCustomerUID: string;

    indicatingPartnerUID: string;
    paymentType: PaymentType;

    firstMonthDate: number;
    firstMonthDateString: string;
    lastMonthDate: number;
    lastMonthDateString: string;
    contractTime: string;

    firstCommissionDate: number;
    firstCommissionDateString: string;
    lastCommissionDate: number;
    lastCommissionDateString: string;

    isInactive: boolean;
}

export class Address {
    cep: number;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: number;
    complement: string;
    longitude: number;
    latitude: number;
    ibge: string;
}

export enum CompanySource {
    GANHEI_LICITACAO = 1,
    SITE = 2,
    ECOMMERCE = 3,
    PARCEIRO_NOTAVEL = 4,
    BNI = 5,
    INSTAGRAM = 6,
    FACEBOOK = 7,
    LINKEDIN = 8,
    TELEFONE = 9,
    INDICACAO_CLIENTE = 10,
    OUTROS = 11
}

export enum PaymentType {
    MENSALIDADE = 1,
    COMISSAO = 2
}



// WEBPACK FOOTER //
// ./src/app/model/company.ts